/**
 * AI-generated code, moderated by lzygmanski
 */
import {Skeleton} from '@/components/ui/skeleton';

const AmbulancePrintSkeleton = () => {
  return (
    <div className="w-full overflow-auto bg-muted/30 p-4">
      <div className="mx-auto w-[210mm] bg-white p-4 shadow-default">
        <div className="space-y-3">
          <div className="space-y-1 border-b border-border pb-2">
            <Skeleton className="h-7 w-64" />
            <Skeleton className="h-3 w-48" />
          </div>

          <div className="space-y-1.5">
            <Skeleton className="h-5 w-40" />
            <div className="grid grid-cols-2 gap-4">
              <Skeleton className="h-10 w-full" />
              <Skeleton className="h-10 w-full" />
            </div>
          </div>

          <div className="space-y-1.5">
            <Skeleton className="h-5 w-40" />
            <div className="grid grid-cols-2 gap-4">
              <Skeleton className="h-8 w-full" />
              <Skeleton className="h-8 w-full" />
            </div>
          </div>

          <div className="space-y-1.5">
            <Skeleton className="h-5 w-40" />
            <div className="space-y-1.5">
              <Skeleton className="h-3 w-full" />
              <Skeleton className="h-3 w-3/4" />
            </div>
          </div>

          <div className="space-y-1.5">
            <Skeleton className="h-5 w-40" />
            <div className="space-y-2">
              <Skeleton className="h-14 w-full bg-muted/60" />
              <Skeleton className="h-16 w-full bg-muted/60" />
              <Skeleton className="h-12 w-full bg-muted/60" />
              <Skeleton className="h-14 w-full bg-muted/60" />
              <Skeleton className="h-13 w-full bg-muted/60" />
            </div>
          </div>

          <div className="space-y-1.5">
            <Skeleton className="h-5 w-40" />
            <div className="space-y-2">
              {/* Blood Pressure group */}
              <div className="space-y-1.5">
                <div className="grid grid-cols-[200px_1fr] gap-2">
                  <Skeleton className="h-7 w-full bg-neutral-100" />
                  <Skeleton className="h-7 w-full bg-neutral-100" />
                </div>
                <div className="grid grid-cols-[200px_1fr] gap-2">
                  <div />
                  <div className="space-y-1.5">
                    <Skeleton className="h-6 w-full bg-muted/80" />
                    <Skeleton className="h-6 w-full bg-muted/80" />
                    <Skeleton className="h-6 w-full bg-muted/80" />
                  </div>
                </div>
              </div>

              {/* Temperature group */}
              <div className="space-y-1.5">
                <div className="grid grid-cols-[200px_1fr] gap-2">
                  <Skeleton className="h-7 w-full bg-neutral-100" />
                  <Skeleton className="h-7 w-full bg-neutral-100" />
                </div>
                <div className="grid grid-cols-[200px_1fr] gap-2">
                  <div />
                  <div className="space-y-1.5">
                    <Skeleton className="h-6 w-full bg-muted/80" />
                    <Skeleton className="h-6 w-full bg-muted/80" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-1.5">
            <Skeleton className="h-5 w-40" />
            <div className="space-y-2">
              {/* First date group */}
              <div className="space-y-1.5">
                <div className="grid grid-cols-[200px_1fr] gap-2">
                  <Skeleton className="h-7 w-full bg-neutral-100" />
                  <Skeleton className="h-7 w-full bg-neutral-100" />
                </div>
                <div className="grid grid-cols-[200px_1fr] gap-2">
                  <div />
                  <div className="space-y-1.5">
                    <Skeleton className="h-7 w-full bg-muted/70" />
                    <Skeleton className="h-7 w-full bg-muted/70" />
                  </div>
                </div>
              </div>

              <div className="space-y-1.5">
                <div className="grid grid-cols-[200px_1fr] gap-2">
                  <Skeleton className="h-7 w-full bg-neutral-100" />
                  <Skeleton className="h-7 w-full bg-neutral-100" />
                </div>
                <div className="grid grid-cols-[200px_1fr] gap-2">
                  <div />
                  <div className="space-y-1.5">
                    <Skeleton className="h-7 w-full bg-muted/70" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmbulancePrintSkeleton;
